export const availableTransLanguageList = [
    {'translationCode': 'ko', 'name': 'Korean', 'name_ko': '한국어'},
	{'translationCode': 'en', 'name': 'English', 'name_ko': '영어'},
	{'translationCode': 'ja', 'name': 'Japanese', 'name_ko': '일본어'},
    {'translationCode': 'vi', 'name': 'Vietnamese', 'name_ko': '베트남어'},
	{'translationCode': 'zh-CN', 'name': 'Chinese (Simplified)', 'name_ko': '중국어(간체)'},
	{'translationCode': 'zh-TW', 'name': 'Chinese (Traditional)', 'name_ko': '중국어(전통)'},
	{'translationCode': 'af', 'name': 'Afrikaans', 'name_ko': '아프리카어'},
	{'translationCode': 'sq', 'name': 'Albanian', 'name_ko': '알바니아'},
	{'translationCode': 'am', 'name': 'Amharic', 'name_ko': '암하라어'},
	{'translationCode': 'ar', 'name': 'Arabic', 'name_ko': '아라비아어'},
	{'translationCode': 'hy', 'name': 'Armenian', 'name_ko': '아르메니아어'},
	{'translationCode': 'as', 'name': 'Assamese', 'name_ko': '아삼어'},
	{'translationCode': 'ay', 'name': 'Aymara', 'name_ko': '아이마라'},
	{'translationCode': 'az', 'name': 'Azerbaijani', 'name_ko': '아제르바이잔어'},
	{'translationCode': 'bm', 'name': 'Bambara', 'name_ko': '밤바라어'},
	{'translationCode': 'eu', 'name': 'Basque', 'name_ko': '바스크어'},
	{'translationCode': 'be', 'name': 'Belarusian', 'name_ko': '벨라루스어'},
	{'translationCode': 'bn', 'name': 'Bengali', 'name_ko': '벵골어'},
	{'translationCode': 'bho', 'name': 'Bhojpuri', 'name_ko': '보지푸리어'},
	{'translationCode': 'bs', 'name': 'Bosnian', 'name_ko': '보스니아어'},
	{'translationCode': 'bg', 'name': 'Bulgarian', 'name_ko': '불가리아어'},
	{'translationCode': 'ca', 'name': 'Catalan', 'name_ko': '카탈로니아어'},
	{'translationCode': 'ceb', 'name': 'Cebuano', 'name_ko': '세부아노어'},
	{'translationCode': 'co', 'name': 'Corsican', 'name_ko': '코르시카어'},
	{'translationCode': 'hr', 'name': 'Croatian', 'name_ko': '크로아티아어'},
	{'translationCode': 'cs', 'name': 'Czech', 'name_ko': '체코어'},
	{'translationCode': 'da', 'name': 'Danish', 'name_ko': '덴마크어'},
	{'translationCode': 'dv', 'name': 'Dhivehi', 'name_ko': '디베히어'},
	{'translationCode': 'doi', 'name': 'Dogri', 'name_ko': '도그리어'},
	{'translationCode': 'nl', 'name': 'Dutch', 'name_ko': '네덜란드어'},
	{'translationCode': 'eo', 'name': 'Esperanto', 'name_ko': '에스페란토어'},
	{'translationCode': 'et', 'name': 'Estonian', 'name_ko': '에스토니아어'},
	{'translationCode': 'ee', 'name': 'Ewe', 'name_ko': '에웨어'},
	{'translationCode': 'fil', 'name': 'Filipino (Tagalog)', 'name_ko': '필리핀어(타갈로그어)'},
	{'translationCode': 'fi', 'name': 'Finnish', 'name_ko': '핀란드어'},
	{'translationCode': 'fr', 'name': 'French', 'name_ko': '프랑스어'},
	{'translationCode': 'fy', 'name': 'Frisian', 'name_ko': '프리지아어'},
	{'translationCode': 'gl', 'name': 'Galician', 'name_ko': '갈리시아어'},
	{'translationCode': 'ka', 'name': 'Georgian', 'name_ko': '조르지아어'},
	{'translationCode': 'de', 'name': 'German', 'name_ko': '독일어'},
	{'translationCode': 'el', 'name': 'Greek', 'name_ko': '그리스어'},
	{'translationCode': 'gn', 'name': 'Guarani', 'name_ko': '과라니어'},
	{'translationCode': 'gu', 'name': 'Gujarati', 'name_ko': '구자라트어'},
	{'translationCode': 'ht', 'name': 'Haitian Creole', 'name_ko': '아이티 크리올어'},
	{'translationCode': 'ha', 'name': 'Hausa', 'name_ko': '하우사어'},
	{'translationCode': 'haw', 'name': 'Hawaiian', 'name_ko': '하와이안어'},
	{'translationCode': 'he or iw', 'name': 'Hebrew', 'name_ko': '헤브라이어'},
	{'translationCode': 'hi', 'name': 'Hindi', 'name_ko': '힌디어'},
	{'translationCode': 'hmn', 'name': 'Hmong', 'name_ko': '몽족어'},
	{'translationCode': 'hu', 'name': 'Hungarian', 'name_ko': '헝가리어'},
	{'translationCode': 'is', 'name': 'Icelandic', 'name_ko': '아이슬란드어'},
	{'translationCode': 'ig', 'name': 'Igbo', 'name_ko': '이그보어'},
	{'translationCode': 'ilo', 'name': 'Ilocano', 'name_ko': '일로카노어'},
	{'translationCode': 'id', 'name': 'Indonesian', 'name_ko': '인도네시아어'},
	{'translationCode': 'ga', 'name': 'Irish', 'name_ko': '아일랜드어'},
	{'translationCode': 'it', 'name': 'Italian', 'name_ko': '이탈리아어'},
	{'translationCode': 'jv or jw', 'name': 'Javanese', 'name_ko': '자바어'},
	{'translationCode': 'kn', 'name': 'Kannada', 'name_ko': '칸나다어'},
	{'translationCode': 'kk', 'name': 'Kazakh', 'name_ko': '카자흐어'},
	{'translationCode': 'km', 'name': 'Khmer', 'name_ko': '크메르어'},
	{'translationCode': 'rw', 'name': 'Kinyarwanda', 'name_ko': '키냐르완다어'},
	{'translationCode': 'gom', 'name': 'Konkani', 'name_ko': '콘카니어'},
	{'translationCode': 'kri', 'name': 'Krio', 'name_ko': '크리오어'},
	{'translationCode': 'ku', 'name': 'Kurdish', 'name_ko': '쿠르드어'},
	{'translationCode': 'ckb', 'name': 'Kurdish (Sorani)', 'name_ko': '쿠르드어(Sorani)'},
	{'translationCode': 'ky', 'name': 'Kyrgyz', 'name_ko': '키르기즈어'},
	{'translationCode': 'lo', 'name': 'Lao', 'name_ko': '라오스어'},
	{'translationCode': 'la', 'name': 'Latin', 'name_ko': '라틴어'},
	{'translationCode': 'lv', 'name': 'Latvian', 'name_ko': '라트비아어'},
	{'translationCode': 'ln', 'name': 'Lingala', 'name_ko': '링갈라어'},
	{'translationCode': 'lt', 'name': 'Lithuanian', 'name_ko': '리투아니아어'},
	{'translationCode': 'lg', 'name': 'Luganda', 'name_ko': '루간다어'},
	{'translationCode': 'lb', 'name': 'Luxembourgish', 'name_ko': '룩셈부르크어'},
	{'translationCode': 'mk', 'name': 'Macedonian', 'name_ko': '마케도니아어'},
	{'translationCode': 'mai', 'name': 'Maithili', 'name_ko': '마이틸리어'},
	{'translationCode': 'mg', 'name': 'Malagasy', 'name_ko': '마다가스카르어'},
	{'translationCode': 'ms', 'name': 'Malay', 'name_ko': '말레이어'},
	{'translationCode': 'ml', 'name': 'Malayalam', 'name_ko': '말라얄람어'},
	{'translationCode': 'mt', 'name': 'Maltese', 'name_ko': '몰티즈어'},
	{'translationCode': 'mi', 'name': 'Maori', 'name_ko': '마오리족어'},
	{'translationCode': 'mr', 'name': 'Marathi', 'name_ko': '마라티어'},
	{'translationCode': 'mni-Mtei', 'name': 'Meiteilon (Manipuri)', 'name_ko': '메이틸론어(마니푸리)'},
	{'translationCode': 'lus', 'name': 'Mizo', 'name_ko': '미조어'},
	{'translationCode': 'mn', 'name': 'Mongolian', 'name_ko': '몽고어'},
	{'translationCode': 'my', 'name': 'Myanmar (Burmese)', 'name_ko': '미얀마어(버마어)'},
	{'translationCode': 'ne', 'name': 'Nepali', 'name_ko': '네팔어'},
	{'translationCode': 'no', 'name': 'Norwegian', 'name_ko': '노르웨이어'},
	{'translationCode': 'ny', 'name': 'Nyanja (Chichewa)', 'name_ko': '냥자어(치체와)'},
	{'translationCode': 'or', 'name': 'Odia (Oriya)', 'name_ko': '오디아어(오리야)'},
	{'translationCode': 'om', 'name': 'Oromo', 'name_ko': '오로모어'},
	{'translationCode': 'ps', 'name': 'Pashto', 'name_ko': '파슈토어'},
	{'translationCode': 'fa', 'name': 'Persian', 'name_ko': '페르시아어'},
	{'translationCode': 'pl', 'name': 'Polish', 'name_ko': '폴란드어'},
	{'translationCode': 'pt', 'name': 'Portuguese (Brazil)', 'name_ko': '포르투갈어(브라질)'},
	{'translationCode': 'pa', 'name': 'Punjabi', 'name_ko': '펀잡어'},
	{'translationCode': 'qu', 'name': 'Quechua', 'name_ko': '케추아어'},
	{'translationCode': 'ro', 'name': 'Romanian', 'name_ko': '루마니아어'},
	{'translationCode': 'ru', 'name': 'Russian', 'name_ko': '러시아어'},
	{'translationCode': 'sm', 'name': 'Samoan', 'name_ko': '사모아어'},
	{'translationCode': 'sa', 'name': 'Sanskrit', 'name_ko': '산스크리트어'},
	{'translationCode': 'gd', 'name': 'Scots Gaelic', 'name_ko': '스코틀랜드 게일어'},
	{'translationCode': 'nso', 'name': 'Sepedi', 'name_ko': '세페디어'},
	{'translationCode': 'sr', 'name': 'Serbian', 'name_ko': '세르비아어'},
	{'translationCode': 'st', 'name': 'Sesotho', 'name_ko': '세소토어'},
	{'translationCode': 'sn', 'name': 'Shona', 'name_ko': '쇼나어'},
	{'translationCode': 'sd', 'name': 'Sindhi', 'name_ko': '신디어'},
	{'translationCode': 'si', 'name': 'Sinhala (Sinhalese)', 'name_ko': '싱할라어'},
	{'translationCode': 'sk', 'name': 'Slovak', 'name_ko': '슬로바키아어'},
	{'translationCode': 'sl', 'name': 'Slovenian', 'name_ko': '슬로베니아어'},
	{'translationCode': 'so', 'name': 'Somali', 'name_ko': '소말리어'},
	{'translationCode': 'es', 'name': 'Spanish', 'name_ko': '스페인어'},
	{'translationCode': 'su', 'name': 'Sundanese', 'name_ko': '순다어'},
	{'translationCode': 'sw', 'name': 'Swahili', 'name_ko': '스와힐리어'},
	{'translationCode': 'sv', 'name': 'Swedish', 'name_ko': '스웨덴어'},
	{'translationCode': 'tl', 'name': 'Tagalog (Filipino)', 'name_ko': '타갈로그어(필리핀어)'},
	{'translationCode': 'tg', 'name': 'Tajik', 'name_ko': '타직어'},
	{'translationCode': 'ta', 'name': 'Tamil', 'name_ko': '타밀어'},
	{'translationCode': 'tt', 'name': 'Tatar', 'name_ko': '타타르어'},
	{'translationCode': 'te', 'name': 'Telugu', 'name_ko': '텔루구어'},
	{'translationCode': 'th', 'name': 'Thai', 'name_ko': '태국어'},
	{'translationCode': 'ti', 'name': 'Tigrinya', 'name_ko': '티그리냐어'},
	{'translationCode': 'ts', 'name': 'Tsonga', 'name_ko': '총가어'},
	{'translationCode': 'tr', 'name': 'Turkish', 'name_ko': '터키어'},
	{'translationCode': 'tk', 'name': 'Turkmen', 'name_ko': '투르크멘어'},
	{'translationCode': 'ak', 'name': 'Twi (Akan)', 'name_ko': '트위어(아칸)'},
	{'translationCode': 'uk', 'name': 'Ukrainian', 'name_ko': '우크라이나어'},
	{'translationCode': 'ur', 'name': 'Urdu', 'name_ko': '우르두어'},
	{'translationCode': 'ug', 'name': 'Uyghur', 'name_ko': '위구르어'},
	{'translationCode': 'uz', 'name': 'Uzbek', 'name_ko': '우즈벡어'},
	{'translationCode': 'cy', 'name': 'Welsh', 'name_ko': '웨일스어'},
	{'translationCode': 'xh', 'name': 'Xhosa', 'name_ko': '코사어'},
	{'translationCode': 'yi', 'name': 'Yiddish', 'name_ko': '이디시어'},
	{'translationCode': 'yo', 'name': 'Yoruba', 'name_ko': '요루바어'},
	{'translationCode': 'zu', 'name': 'Zulu', 'name_ko': '줄루어'},
];